import React from 'react';
import { withRouter } from 'react-router-dom';
import VMovTable from './VMovTable.jsx';
import VMovCorrTable from './VMovCorrTable.jsx';

class VisualizarMovimentacao extends React.Component {

    constructor() {

        super();

        this.state = {
            centro: "",
            centroId: 0,
            id: "",
            banco: "",
            data: "",
            historico: "",
            descricao: "",
            valor: "",
            notaFiscal: "",
            comprovante: "",
            analiseContabil: "",
            ghg: "",
            contaId: "",
            status: "",
            errBanco: "",
            errData: "",
            errHistorico: "",
            errDescricao: "",
            errValor: "",
            errSaldo: "",
            errNotaFiscal: "",
            errComprovante: "",
            errAnaliseContabil: "",
            errGhg: "",
            errContaId: "",
            corrBanco: "",
            corrData: "",
            corrHistorico: "",
            corrDescricao: "",
            corrValor: "",
            corrSaldo: "",
            corrNotaFiscal: "",
            corrComprovante: "",
            corrAnaliseContabil: "",
            corrGhg: "",
            corrContaId: "",
            cadastradoPor: "",
            corrigidoPor: "",
            conta: "",
            codConta: "",
            codMovimentacao: "",
            corrConta: "",
            corrCodConta: "",
            corrCodMovimentacao: "",
            cadastradoPorNome: "",
            corrigidoPorNome: "",
            bancoNome: "",
            corrBancoNome: "",
            filtroAno: "",
            filtroMes: "",
            vecMovPrev: null,
            vecMov: null
        };

        this.downloadCorrNotaFiscal = this.downloadCorrNotaFiscal.bind(this);
        this.downloadNotaFiscal = this.downloadNotaFiscal.bind(this);
        this.downloadCorrComprovante = this.downloadCorrComprovante.bind(this);
        this.downloadComprovante = this.downloadComprovante.bind(this);
        this.anexarNotaCorrigida = this.anexarNotaCorrigida.bind(this);
        this.anexarComprovanteCorrigido = this.anexarComprovanteCorrigido.bind(this);
        this.voltar = this.voltar.bind(this);
        this.editar = this.editar.bind(this);
        this.remover = this.remover.bind(this);
        this.aprovar = this.aprovar.bind(this);
        this.corrigir = this.corrigir.bind(this);
        this.prev = this.prev.bind(this);
        this.next = this.next.bind(this);

    }

    moneyMask(str_val) {

        let res = ""; 
        let vec = str_val.split(".");
        let c = 0;

        for (let i = vec[0].length - 1; i >= 0; i--) {

            if (c !== 0 && c % 3 === 0 && vec[0][i] !== "-") {
                res = vec[0][i] + "." + res;
            } else {
                res = vec[0][i] + res;
            }   

            c++;

        }   

        if (vec[1] !== undefined) res = res + "," + vec[1];
        else res = res + ",00";

        return res;

    }

    formatarValor(s) {
        if (s === null) return "";
        return this.moneyMask(s);
    }

    status(s) {
        if (s === 1) return "Aprovado";
        else if (s === 2 || s === 3) return "Corrigido";
        else return "Lançado";
    }

    downloadNotaFiscal() {

        fetch("/api/movimentacao/download/nf/" + this.state.id, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.blob())
        .then(blob => {

            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = this.state.id + "_nf_" + this.state.notaFiscal;
            a.click();

        });

    }

    downloadCorrNotaFiscal() {

        fetch("/api/movimentacao/download/corrnf/" + this.state.id, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.blob())
        .then(blob => {

            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = this.state.id + "_cnf_" + this.state.corrNotaFiscal;
            a.click();

        });

    }

    downloadComprovante() {

        fetch("/api/movimentacao/download/cp/" + this.state.id, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.blob())
        .then(blob => {

            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = this.state.id + "_cp_" + this.state.comprovante;
            a.click();

        });

    }

    downloadCorrComprovante() {

        fetch("/api/movimentacao/download/corrcp/" + this.state.id, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.blob())
        .then(blob => {

            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = this.state.id + "_ccp_" + this.state.corrComprovante;
            a.click();

        });

    }

    anexarNotaCorrigida() {

        if (localStorage.roleMovimentacoes === "escrever"
            || localStorage.roleMovimentacoes === "corrigir") {

            let obj = {
                centro: this.state.centro,
                centroId: this.state.centroId,
                id: this.state.id,
                filtroAno: this.state.filtroAno,
                filtroMes: this.state.filtroMes,
                vecMovPrev: this.state.vecMovPrev,
                vecMov: this.state.vecMov
            };

            this.props.history.push({
                pathname: "/anexarnotacorrigida",
                state: obj
            });

        } else {

            this.props.errMsgHandler("Acesso não autorizado.");

        }

    }

    anexarComprovanteCorrigido() {

        if (localStorage.roleMovimentacoes === "escrever"
            || localStorage.roleMovimentacoes === "corrigir") {

            let obj = {
                centro: this.state.centro,
                centroId: this.state.centroId,
                id: this.state.id,
                filtroAno: this.state.filtroAno,
                filtroMes: this.state.filtroMes,
                vecMovPrev: this.state.vecMovPrev,
                vecMov: this.state.vecMov
            };

            this.props.history.push({
                pathname: "/anexarcomprovantecorrigido",
                state: obj
            });

        } else {

            this.props.errMsgHandler("Acesso não autorizado.");

        }

    }

    voltar() {

        let obj = {
            row: {
                id: this.state.centroId,
                data: [ this.state.centro ],
                filtroAno: this.state.filtroAno,
                filtroMes: this.state.filtroMes
            }
        };

        this.props.history.push({
            pathname: "/movimentacoescentro",
            state: obj
        });

    }

    editar() {

        if (this.state.status === 1) {

            this.props.errMsgHandler("Esta movimentação financeira já foi aprovada.");

        } else if (this.state.status === 2 || this.state.status === 3) {

            this.props.errMsgHandler("Esta movimentação financeira já foi corrigida.");

        } else {

            let obj = {
                centro: this.state.centro,
                centroId: this.state.centroId,
                id: this.state.id,
                banco: this.state.banco,
                data: this.state.data,
                historico: this.state.historico,
                descricao: this.state.descricao,
                valor: this.state.valor,
                notaFiscal: this.state.notaFiscal,
                comprovante: this.state.comprovante,
                analiseContabil: this.state.analiseContabil,
                ghg: this.state.ghg,
                conta: this.state.contaId,
                contaNome: this.state.conta,
                codConta: this.state.codConta,
                codMovimentacao: this.state.codMovimentacao,
                filtroAno: this.state.filtroAno,
                filtroMes: this.state.filtroMes,
                vecMovPrev: this.state.vecMovPrev,
                vecMov: this.state.vecMov
            };

            this.props.history.push({
                pathname: "/editarmovimentacao",
                state: obj
            });

        }

    }

    remover() {

        if (this.state.status === 1) {

            this.props.errMsgHandler("Esta movimentação financeira já foi aprovada.");

        } else if (this.state.status === 2 || this.state.status === 3) {

            this.props.errMsgHandler("Esta movimentação financeira já foi corrigida.");

        } else {

            let obj = {
                centro: this.state.centro,
                centroId: this.state.centroId,
                id: this.state.id,
                filtroAno: this.state.filtroAno,
                filtroMes: this.state.filtroMes,
                vecMovPrev: this.state.vecMovPrev,
                vecMov: this.state.vecMov
            };

            this.props.history.push({
                pathname: "/removermovimentacao",
                state: obj
            });

        }

    }

    aprovar() {

        if (this.state.status === 1) {

            this.props.errMsgHandler("Esta movimentação financeira já foi aprovada.");

        } else if (this.state.status === 2 || this.state.status === 3) {

            this.props.errMsgHandler("Esta movimentação financeira já foi corrigida.");

        } else {

            let obj = {
                centro: this.state.centro,
                centroId: this.state.centroId,
                id: this.state.id,
                filtroAno: this.state.filtroAno,
                filtroMes: this.state.filtroMes,
                vecMovPrev: this.state.vecMovPrev,
                vecMov: this.state.vecMov
            };

            this.props.history.push({
                pathname: "/aprovarmovimentacao",
                state: obj
            });

        }

    }

    corrigir() {

        if (this.state.status === 1 && localStorage.roleMovimentacoes !== "corrigir") {

            this.props.errMsgHandler("Esta movimentação financeira já foi aprovada.");

        } else if (this.state.status === 2 && localStorage.roleMovimentacoes !== "corrigir") {

            this.props.errMsgHandler("Esta movimentação financeira já foi corrigida.");

        } else {

            let obj = {
                centro: this.state.centro,
                centroId: this.state.centroId,
                id: this.state.id,
                banco: this.state.banco,
                data: this.state.data,
                historico: this.state.historico,
                descricao: this.state.descricao,
                valor: this.state.valor,
                notaFiscal: this.state.notaFiscal,
                comprovante: this.state.comprovante,
                analiseContabil: this.state.analiseContabil,
                ghg: this.state.ghg,
                contaId: this.state.contaId,
                status: this.state.status,
                conta: this.state.conta,
                codConta: this.state.codConta,
                codMovimentacao: this.state.codMovimentacao,
                cadastradoPor: this.state.cadastradoPor,
                cadastradoPorNome: this.state.cadastradoPorNome,
                edErrBanco: this.state.errBanco,
                edErrData: this.state.errData,
                edErrHistorico: this.state.errHistorico,
                edErrDescricao: this.state.errDescricao,
                edErrValor: this.state.errValor,
                edErrNotaFiscal: this.state.errNotaFiscal,
                edErrComprovante: this.state.errComprovante,
                edErrAnaliseContabil: this.state.errAnaliseContabil,
                edErrGhg: this.state.errGhg,
                edErrContaId: this.state.errContaId,
                corrBanco: this.state.corrBanco,
                corrData: this.state.corrData,
                corrHistorico: this.state.corrHistorico,
                corrDescricao: this.state.corrDescricao,
                corrValor: this.state.corrValor,
                corrNotaFiscal: this.state.corrNotaFiscal,
                corrComprovante: this.state.corrComprovante,
                corrAnaliseContabil: this.state.corrAnaliseContabil,
                corrGhg: this.state.corrGhg,
                corrContaId: this.state.corrContaId,
                corrConta: this.state.corrConta,
                corrCodConta: this.state.corrCodConta,
                corrCodMovimentacao: this.state.corrCodMovimentacao,
                filtroAno: this.state.filtroAno,
                filtroMes: this.state.filtroMes,
                vecMovPrev: this.state.vecMovPrev,
                vecMov: this.state.vecMov
            };

            this.props.history.push({
                pathname: "/corrigirmovimentacao",
                state: obj
            });

        }

    }

    prev() {

        if (this.state.vecMovPrev.length > 0) {

            let vecMovPrev = this.state.vecMovPrev;
            let vecMov = this.state.vecMov;
            vecMov.unshift(vecMovPrev.pop());

            this.props.history.push({
                pathname: "/visualizarmovimentacao",
                state: {
                    row: vecMov[0],
                    filtroAno: this.state.filtroAno,
                    filtroMes: this.state.filtroMes,
                    vecMovPrev: vecMovPrev,
                    vecMov: vecMov
                }
            });

            window.location.reload();

        }

    }

    next() {

        if (this.state.vecMov.length > 1) {

            let vecMovPrev = this.state.vecMovPrev;
            let vecMov = this.state.vecMov;
            vecMovPrev.push(vecMov.shift());

            this.props.history.push({
                pathname: "/visualizarmovimentacao",
                state: {
                    row: vecMov[0],
                    filtroAno: this.state.filtroAno,
                    filtroMes: this.state.filtroMes,
                    vecMovPrev: vecMovPrev,
                    vecMov: vecMov
                }
            });

            window.location.reload();

        }

    }

    componentDidMount() {

        if (localStorage.roleMovimentacoes === "nenhuma") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/movimentacoes";
        }

        let id = this.props.location.state.row.id;
        let filtroAno = this.props.location.state.filtroAno;
        let filtroMes = this.props.location.state.filtroMes;
        let vecMovPrev = this.props.location.state.vecMovPrev;
        let vecMov = this.props.location.state.vecMov;

        this.setState({ id: id });
        this.setState({ filtroAno: filtroAno });
        this.setState({ filtroMes: filtroMes });
        this.setState({ vecMovPrev: vecMovPrev });
        this.setState({ vecMov: vecMov });

        fetch("/api/centro/centromovimentacao/" + id, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ centro: responseJson.nome });
            this.setState({ centroId: responseJson.id });

            fetch("/api/movimentacao/" + id, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response2 => response2.json())
            .then(responseJson2 => {

                this.setState({ id: responseJson2.id });
                this.setState({ banco: responseJson2.banco });
                this.setState({ data: responseJson2.data });
                this.setState({ historico: responseJson2.historico });
                this.setState({ descricao: responseJson2.descricao });
                this.setState({ valor: responseJson2.valor });
                this.setState({ notaFiscal: responseJson2.nota_fiscal });
                this.setState({ comprovante: responseJson2.comprovante });
                this.setState({ analiseContabil: responseJson2.analise_contabil });
                this.setState({ ghg: responseJson2.ghg });
                this.setState({ contaId: responseJson2.conta_id });
                this.setState({ status: responseJson2.status });
                this.setState({ errBanco: responseJson2.err_banco });
                this.setState({ errData: responseJson2.err_data });
                this.setState({ errHistorico: responseJson2.err_historico });
                this.setState({ errDescricao: responseJson2.err_descricao });
                this.setState({ errValor: responseJson2.err_valor });
                this.setState({ errNotaFiscal: responseJson2.err_nota_fiscal });
                this.setState({ errComprovante: responseJson2.err_comprovante });
                this.setState({ errAnaliseContabil: responseJson2.err_analise_contabil });
                this.setState({ errGhg: responseJson2.err_ghg });
                this.setState({ errContaId: responseJson2.err_conta_id });
                this.setState({ corrBanco: responseJson2.corr_banco });
                this.setState({ corrData: responseJson2.corr_data });
                this.setState({ corrHistorico: responseJson2.corr_historico });
                this.setState({ corrDescricao: responseJson2.corr_descricao });
                this.setState({ corrValor: responseJson2.corr_valor });
                this.setState({ corrNotaFiscal: responseJson2.corr_nota_fiscal });
                this.setState({ corrComprovante: responseJson2.corr_comprovante });
                this.setState({ corrAnaliseContabil: responseJson2.corr_analise_contabil });
                this.setState({ corrGhg: responseJson2.corr_ghg });
                this.setState({ corrContaId: responseJson2.corr_conta_id });
                this.setState({ cadastradoPor: responseJson2.cadastrado_por });
                this.setState({ corrigidoPor: responseJson2.corrigido_por });
                this.setState({ conta: responseJson2.conta });
                this.setState({ codConta: responseJson2.cod_conta });
                this.setState({ codMovimentacao: responseJson2.cod_movimentacao });
                this.setState({ corrConta: responseJson2.corr_conta });
                this.setState({ corrCodConta: responseJson2.corr_cod_conta });
                this.setState({ corrCodMovimentacao: responseJson2.corr_cod_movimentacao });
                this.setState({ cadastradoPorNome: responseJson2.cadastrado_por_nome });
                this.setState({ corrigidoPorNome: responseJson2.corrigido_por_nome });
                this.setState({ bancoNome: responseJson2.banco_nome });
                this.setState({ corrBancoNome: responseJson2.corr_banco_nome });

            });

        });

    } 

    render() {
        return(
            <div>
                <h1 id="visualizar-movimentacao-title">Movimentação Financeira</h1><br />
                <p id="visualizar-movimentacao-centro"
                    Style={ "float: left; margin-right: 20px;" }>
                    <b>Centro: </b> { this.state.centro }
                </p>
                <p className={ "vismov-cad-corr" }
                    Style={ "float: left; margin-right: 20px;" }>
                    <b>Status: </b> { this.status(this.state.status) }
                </p>
                <p className={ "vismov-cad-corr" }
                    Style={ "float: left; margin-right: 20px;" }>
                    <b>Cadastrado por: </b> { this.state.cadastradoPorNome }
                </p>
                { (this.state.status !== 2 && this.state.status !== 3) &&
                    <VMovTable
                        id={ this.state.id }
                        banco={ this.state.banco }
                        bancoNome={ this.state.bancoNome }
                        data={ this.state.data }
                        historico={ this.state.historico }
                        descricao={ this.state.descricao }
                        valor={ this.formatarValor(this.state.valor) }
                        notaFiscal={ this.state.notaFiscal }
                        comprovante={ this.state.comprovante }
                        analiseContabil={ this.state.analiseContabil }
                        ghg={ this.state.ghg }
                        conta={ this.state.conta }
                        codConta={ this.state.codConta }
                        codMovimentacao={ this.state.codMovimentacao }
                        errBanco={ this.state.errBanco }
                        errData={ this.state.errData }
                        errHistorico={ this.state.errHistorico }
                        errDescricao={ this.state.errDescricao }
                        errValor={ this.state.errValor }
                        errNotaFiscal={ this.state.errNotaFiscal }
                        errComprovante={ this.state.errComprovante }
                        errAnaliseContabil={ this.state.errAnaliseContabil }
                        errGhg={ this.state.errGhg }
                        errContaId={ this.state.errContaId }
                        downloadNotaFiscal={ this.downloadNotaFiscal }
                        downloadComprovante={ this.downloadComprovante } /> }
                { (this.state.status === 2 || this.state.status === 3) &&
                    <VMovCorrTable
                        id={ this.state.id }
                        corrigidoPorNome={ this.state.corrigidoPorNome }
                        banco={ this.state.banco }
                        bancoNome={ this.state.bancoNome }
                        data={ this.state.data }
                        historico={ this.state.historico }
                        descricao={ this.state.descricao }
                        valor={ this.formatarValor(this.state.valor) }
                        notaFiscal={ this.state.notaFiscal }
                        comprovante={ this.state.comprovante }
                        analiseContabil={ this.state.analiseContabil }
                        ghg={ this.state.ghg }
                        conta={ this.state.conta }
                        codConta={ this.state.codConta }
                        codMovimentacao={ this.state.codMovimentacao }
                        downloadNotaFiscal={ this.downloadNotaFiscal }
                        errBanco={ this.state.errBanco }
                        errData={ this.state.errData }
                        errHistorico={ this.state.errHistorico }
                        errDescricao={ this.state.errDescricao }
                        errValor={ this.state.errValor }
                        errNotaFiscal={ this.state.errNotaFiscal }
                        errComprovante={ this.state.errComprovante }
                        errAnaliseContabil={ this.state.errAnaliseContabil }
                        errGhg={ this.state.errGhg }
                        errContaId={ this.state.errContaId }
                        corrBanco={ this.state.corrBanco }
                        corrBancoNome={ this.state.corrBancoNome }
                        corrData={ this.state.corrData }
                        corrHistorico={ this.state.corrHistorico }
                        corrDescricao={ this.state.corrDescricao }
                        corrValor={ this.formatarValor(this.state.corrValor) }
                        corrNotaFiscal={ this.state.corrNotaFiscal }
                        corrComprovante={ this.state.corrComprovante }
                        corrAnaliseContabil={ this.state.corrAnaliseContabil }
                        corrGhg={ this.state.corrGhg }
                        corrConta={ this.state.corrConta }
                        corrCodConta={ this.state.corrCodConta }
                        corrCodMovimentacao={ this.state.corrCodMovimentacao }
                        downloadCorrNotaFiscal={ this.downloadCorrNotaFiscal }
                        downloadComprovante={ this.downloadComprovante }
                        downloadCorrComprovante={ this.downloadCorrComprovante }
                        anexarNotaCorrigida={ this.anexarNotaCorrigida }
                        anexarComprovanteCorrigido={ this.anexarComprovanteCorrigido } /> }
                <br />
                <br />
                <button Class="visualizar-movimentacao-btn"
                    id="visualizar-movimentacao-voltar-btn"
                    onClick={ this.voltar }>Voltar</button>
                { (localStorage.roleMovimentacoes === "escrever"
                    || localStorage.roleMovimentacoes === "corrigir") &&
                    <button Class="visualizar-movimentacao-btn"
                        id="visualizar-movimentacao-editar-btn"
                        onClick={ this.editar }>Editar</button> }
                { (localStorage.roleMovimentacoes === "escrever"
                    || localStorage.roleMovimentacoes === "corrigir") &&
                    <button Class="visualizar-movimentacao-btn"
                        id="visualizar-movimentacao-remover-btn"
                        onClick={ this.remover }>Remover</button> }
                { localStorage.roleMovimentacoes === "corrigir" &&
                    <button Class="visualizar-movimentacao-btn"
                        id="visualizar-movimentacao-aprovar-btn"
                        onClick={ this.aprovar }>Aprovar</button> }
                { localStorage.roleMovimentacoes === "corrigir" &&
                    <button Class="visualizar-movimentacao-btn"
                        id="visualizar-movimentacao-corrigir-btn"
                        onClick={ this.corrigir }>Corrigir</button> }
                <button id="visualizar-movimentacao-prev-btn" onClick={ this.prev }>
                    { '<' }
                </button>
                <button id="visualizar-movimentacao-next-btn" onClick={ this.next }>
                    { '>' }
                </button>
                <br /><br />
            </div>
        );
    }

}

export default withRouter(VisualizarMovimentacao);

